import { render } from "./PreviewPdf.vue?vue&type=template&id=1f788ede&scoped=true&ts=true"
import script from "./PreviewPdf.vue?vue&type=script&lang=ts"
export * from "./PreviewPdf.vue?vue&type=script&lang=ts"

import "./PreviewPdf.vue?vue&type=style&index=0&id=1f788ede&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f788ede"]])

export default __exports__